/**
 * @generated SignedSource<<fafe320fd09fc54f37472d7a31881ad4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VoterCardFragment$data = {
  readonly address: {
    readonly resolvedName: {
      readonly address: string;
      readonly name: string | null;
    };
  };
  readonly statement: {
    readonly summary: string | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"DelegateProfileImageFragment" | "VoterPanelActionsFragment">;
  readonly " $fragmentType": "VoterCardFragment";
};
export type VoterCardFragment$key = {
  readonly " $data"?: VoterCardFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"VoterCardFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VoterCardFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Address",
      "kind": "LinkedField",
      "name": "address",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ResolvedName",
          "kind": "LinkedField",
          "name": "resolvedName",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "address",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DelegateStatement",
      "kind": "LinkedField",
      "name": "statement",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "summary",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "VoterPanelActionsFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DelegateProfileImageFragment"
    }
  ],
  "type": "Delegate",
  "abstractKey": null
};

(node as any).hash = "f6ca41bf85f2db9c59815bc93c108b96";

export default node;
